export default "__VITE_ASSET__80b2c367__"